import appConst from "../../Utilities/appConst.json";

export const errorMessages = {
  sender: {
    firstName: {
      emptyErrorMsg: appConst.VALIDATION_TEXT_REQUIRED_FIELD,
      lengthErrorMsg: appConst.VALIDATION_TEXT_MINIMUM_LENGTH,
      formatErrorMsg: appConst.VALIDATION_TEXT_LETTERS_ONLY,
      spaceErrorMsg: appConst.VALIDATION_TEXT_UNNECESSARY_SPACE,
    },
    lastName: {
      emptyErrorMsg: appConst.VALIDATION_TEXT_REQUIRED_FIELD,
      lengthErrorMsg: appConst.VALIDATION_TEXT_MINIMUM_LENGTH,
      formatErrorMsg: appConst.VALIDATION_TEXT_LETTERS_ONLY,
      spaceErrorMsg: appConst.VALIDATION_TEXT_UNNECESSARY_SPACE,
    },
    city: {
      emptyErrorMsg: appConst.VALIDATION_TEXT_REQUIRED_FIELD,
    },
    street: {
      emptyErrorMsg: appConst.VALIDATION_TEXT_REQUIRED_FIELD,
    },
    buildingNum: {
      emptyErrorMsg: appConst.VALIDATION_TEXT_REQUIRED_FIELD,
      formatErrorMsg: appConst.VALIDATION_NUMBER_NUMBERS_ONLY,
      prefixErrorMsg: appConst.VALIDATION_NUMBER_CAN_NOT_START_WITH,
    },
    ApartmentNum: {
      formatErrorMsg: appConst.VALIDATION_NUMBER_NUMBERS_ONLY,
      prefixErrorMsg: appConst.VALIDATION_NUMBER_CAN_NOT_START_WITH,
    },
    zip: { formatErrorMsg: appConst.VALIDATION_NUMBER_NUMBERS_ONLY },
    phoneNumber: {
      emptyErrorMsg: appConst.VALIDATION_TEXT_REQUIRED_FIELD,
      lengthErrorMsg: appConst.VALIDATION_TEL_LENGTH,
      formatErrorMsg: appConst.VALIDATION_NUMBER_NUMBERS_ONLY,
      prefixErrorMsg: appConst.VALIDATION_NUMBER_CAN_NOT_START_WITH,
    },
    areaCode: {
      emptyErrorMsg: appConst.VALIDATION_TEXT_REQUIRED_FIELD,
    },
  },
  receiver: {
    firstName: {
      emptyErrorMsg: appConst.VALIDATION_TEXT_REQUIRED_FIELD,
      lengthErrorMsg: appConst.VALIDATION_TEXT_MINIMUM_LENGTH,
      formatErrorMsg: appConst.VALIDATION_TEXT_LETTERS_ONLY,
      spaceErrorMsg: appConst.VALIDATION_TEXT_UNNECESSARY_SPACE,
    },
    lastName: {
      emptyErrorMsg: appConst.VALIDATION_TEXT_REQUIRED_FIELD,
      lengthErrorMsg: appConst.VALIDATION_TEXT_MINIMUM_LENGTH,
      formatErrorMsg: appConst.VALIDATION_TEXT_LETTERS_ONLY,
      spaceErrorMsg: appConst.VALIDATION_TEXT_UNNECESSARY_SPACE,
    },
    city: {
      emptyErrorMsg: appConst.VALIDATION_TEXT_REQUIRED_FIELD,
    },
    street: {
      emptyErrorMsg: appConst.VALIDATION_TEXT_REQUIRED_FIELD,
    },
    buildingNum: {
      emptyErrorMsg: appConst.VALIDATION_TEXT_REQUIRED_FIELD,
      formatErrorMsg: appConst.VALIDATION_NUMBER_NUMBERS_ONLY,
      prefixErrorMsg: appConst.VALIDATION_NUMBER_CAN_NOT_START_WITH,
    },
    ApartmentNum: {
      formatErrorMsg: appConst.VALIDATION_NUMBER_NUMBERS_ONLY,
      prefixErrorMsg: appConst.VALIDATION_NUMBER_CAN_NOT_START_WITH,
    },
    zip: { formatErrorMsg: appConst.VALIDATION_NUMBER_NUMBERS_ONLY },
    phoneNumber: {
      emptyErrorMsg: appConst.VALIDATION_TEXT_REQUIRED_FIELD,
      lengthErrorMsg: appConst.VALIDATION_TEL_LENGTH,
      formatErrorMsg: appConst.VALIDATION_NUMBER_NUMBERS_ONLY,
      prefixErrorMsg: appConst.VALIDATION_NUMBER_CAN_NOT_START_WITH,
    },
    areaCode: {
      emptyErrorMsg: appConst.VALIDATION_TEXT_REQUIRED_FIELD,
    },
  },
  business: {
    company: {
      emptyErrorMsg: appConst.VALIDATION_TEXT_REQUIRED_FIELD,
      lengthErrorMsg: appConst.VALIDATION_TEXT_MINIMUM_LENGTH,
      formatErrorMsg: appConst.VALIDATION_TEXT_LETTERS_ONLY,
      spaceErrorMsg: appConst.VALIDATION_TEXT_UNNECESSARY_SPACE,
    },
    companyId: {
      emptyErrorMsg: appConst.VALIDATION_TEXT_REQUIRED_FIELD,
      formatErrorMsg: appConst.VALIDATION_NUMBER_NUMBERS_ONLY,
      spaceErrorMsg: appConst.VALIDATION_TEXT_UNNECESSARY_SPACE,
    },
    city: {
      emptyErrorMsg: appConst.VALIDATION_TEXT_REQUIRED_FIELD,
    },
    street: {
      emptyErrorMsg: appConst.VALIDATION_TEXT_REQUIRED_FIELD,
    },
  },
  collectionBucket: {
    phoneNumber: {
      emptyErrorMsg: appConst.VALIDATION_TEXT_REQUIRED_FIELD,
      lengthErrorMsg: appConst.VALIDATION_TEL_LENGTH,
      formatErrorMsg: appConst.VALIDATION_NUMBER_NUMBERS_ONLY,
      prefixErrorMsg: appConst.VALIDATION_NUMBER_CAN_NOT_START_WITH,
    },
    areaCode: {
      emptyErrorMsg: appConst.VALIDATION_TEXT_REQUIRED_FIELD,
    },
  },
};
